import { NavigationContext } from '@wix/gg-components/orchestrator';
import { BI_CONSTANTS } from '../hooks/biLogger/biConstants';
import { biLogger } from '../hooks';

export const welcomeNextAction = async (context: NavigationContext) => {
  biLogger.actionClicked({
    action: BI_CONSTANTS.ACTION.WELCOME_PAGE_NEXT,
    button_name: BI_CONSTANTS.BUTTON_NAME.GET_STARTED,
  });
};
